<template>
  <div class="slide">
    <div class="loop">
      <div class="tem_49_23_c w-cs" id="qqservice_tem_49_23">
        <ul class="w-cs-btn">
          <li class="w-cs-list w-cs-phoneBtn ">
            <a href="javascript:void(0);" class="w-cs-icon"><img src="../assets/268.png"></a>
            <ul class="w-cs-menu w-cs-phone" style="width: 200px; left: 0px;">
              <li><h4>客服电话</h4></li>
              <li>15116906730</li>
            </ul>
          </li>
          <li class="w-cs-list w-cs-qqBtn ">
            <a href="javascript:void(0);" class="w-cs-icon"><img src="../assets/270.png"></a>
            <ul class="w-cs-menu w-cs-qq" style="width: 200px; left: 0px;">
              <li><a href="//wpa.qq.com/msgrd?v=3&amp;uin=58655961&amp;site=qq&amp;menu=yes" target="_blank" class="qq">QQ客服：58655961</a></li>
              <li><a href="//wpa.qq.com/msgrd?v=3&amp;uin=2511887456&amp;site=qq&amp;menu=yes" target="_blank" class="qq">QQ客服：2511887456</a></li>
            </ul>
          </li>
          <li class="w-cs-list w-cs-clockBtn ">
            <a href="javascript:void(0);" class="w-cs-icon"><img src="../assets/271.png"></a>
            <ul class="w-cs-menu w-cs-clock" style="width: 200px; left: 0px;">
              <li><h4>服务时间</h4></li>
              <li>周一至周五 9:00-18:00</li>
            </ul>
          </li>
          <li class="w-cs-list w-cs-qrcodeBtn ">
            <a href="javascript:void(0);" class="w-cs-icon"><img src="../assets/269.png"></a>
            <ul class="w-cs-menu w-cs-qrcode" style="width: 200px; left: 0px;">
              <li class="w-cs-qrcode-img"><img src="//nwzimg.wezhan.cn/contents/sitefiles2008/10040066/images/1292645.png" alt=""></li>
            </ul>
          </li>
          <li class="w-cs-list w-cs-qrcodeBtn ">
            <a href="javascript:void(0);" class="w-cs-icon" @click="toTop"><img src="../assets/272.png"></a>
          </li>
        </ul>
      </div>
    </div>


  </div>
</template>

<script>
export default {
  data() {
    return {
      msg: "HelloWorld,I am PC",
      active: "",
    };
  },
  mounted() {
    // 此处true需要加上，不加滚动事件可能绑定不成功
    window.addEventListener("scroll", this.handleScroll, true);
  },
  methods: {
    handleScroll(e) {
      let scrolltop = e.target.scrollTop;
      scrolltop > 30 ? (this.gotop = true) : (this.gotop = false);
    },
    toTop() {

      let top = document.documentElement.scrollTop || document.body.scrollTop;
      // 实现滚动效果
      const timeTop = setInterval(() => {
        document.body.scrollTop = document.documentElement.scrollTop = top -= 50;
        if (top <= 0) {
          clearInterval(timeTop);
        }
      }, 10);
    },


  }
}
</script>

<style scoped>
.gotop {
  text-align: center;
  position: fixed;
  right: 50px;
  bottom: 30px;
  cursor: pointer;
  padding: 10px;
  border-radius: 50%;
  background: white;
  color: #000000;
  z-index: 100;
}
ul{
  list-style: none;
}
.tem_49_23_c{
  position: fixed;
  top:60%;
  right: 0;
}
.w-cs-icon{
  display: block;
  position: relative;
  z-index: 100;
  width: 40px;
  height: 40px;
  padding: 5px;
  background-color: rgba(86, 171, 226,1);
  background-image: none;
  background-repeat: repeat;
  background-position: 0 0;
  border: solid 1px #fff;
  border-bottom: none;
  text-align: center;
  color: rgba(255,255,255,1);
  text-decoration: none;
}
 .w-cs-menu {
   display: none;
  margin: 0;
  position: absolute;
  top: 15px;
  right: 61px;
  padding: 10px 0;
  background-color: rgba(122, 189, 232,1);
  background-repeat: repeat;
  background-position: 0 0;
  border: solid 1px #fff;
  border-radius: 0px;
  list-style: none;
  white-space: nowrap;
  z-index: 1;
   color: #fff;
   text-align: center;
   height: 160px;
}
 .w-cs-list:hover .w-cs-menu{
   display: block;
   left: -160px !important;
   position: absolute;
 }
.w-cs-menu:hover{
  display: block;
}
.qq{
  display: block;
  text-decoration: none;
  margin-top: 20px;
  color: #fff;
  font-size: 16px;
}
</style>
<template>
  <div class="slide">
    <div class="loop">
      <div class="tem_49_23_c w-cs" id="qqservice_tem_49_23">
        <ul class="w-cs-btn">
          <li class="w-cs-list w-cs-phoneBtn ">
            <a href="javascript:void(0);" class="w-cs-icon"><img src="../assets/268.png"></a>
            <ul class="w-cs-menu w-cs-phone" style="width: 200px; left: 0px;">
              <li><h4>客服电话</h4></li>
              <li>15116906730</li>
            </ul>
          </li>
          <li class="w-cs-list w-cs-qqBtn ">
            <a href="javascript:void(0);" class="w-cs-icon"><img src="../assets/270.png"></a>
            <ul class="w-cs-menu w-cs-qq" style="width: 200px; left: 0px;">
              <li><a href="//wpa.qq.com/msgrd?v=3&amp;uin=58655961&amp;site=qq&amp;menu=yes" target="_blank" class="qq">QQ客服：58655961</a></li>
              <li><a href="//wpa.qq.com/msgrd?v=3&amp;uin=2511887456&amp;site=qq&amp;menu=yes" target="_blank" class="qq">QQ客服：2511887456</a></li>
            </ul>
          </li>
          <li class="w-cs-list w-cs-clockBtn ">
            <a href="javascript:void(0);" class="w-cs-icon"><img src="../assets/271.png"></a>
            <ul class="w-cs-menu w-cs-clock" style="width: 200px; left: 0px;">
              <li><h4>服务时间</h4></li>
              <li>周一至周五 9:00-18:00</li>
            </ul>
          </li>
          <li class="w-cs-list w-cs-qrcodeBtn ">
            <a href="javascript:void(0);" class="w-cs-icon"><img src="../assets/269.png"></a>
            <ul class="w-cs-menu w-cs-qrcode" style="width: 200px; left: 0px;">
              <li class="w-cs-qrcode-img"><img src="//nwzimg.wezhan.cn/contents/sitefiles2008/10040066/images/1292645.png" alt=""></li>
            </ul>
          </li>
          <li class="w-cs-list w-cs-qrcodeBtn ">
            <a href="javascript:void(0);" class="w-cs-icon" @click="toTop"><img src="../assets/272.png"></a>
          </li>
        </ul>
      </div>
    </div>


  </div>
</template>

<script>
export default {
  data() {
    return {
      msg: "HelloWorld,I am PC",
      active: "",
    };
  },
  mounted() {
    // 此处true需要加上，不加滚动事件可能绑定不成功
    window.addEventListener("scroll", this.handleScroll, true);
  },
  methods: {
    handleScroll(e) {
      let scrolltop = e.target.scrollTop;
      scrolltop > 30 ? (this.gotop = true) : (this.gotop = false);
    },
    toTop() {

      let top = document.documentElement.scrollTop || document.body.scrollTop;
      // 实现滚动效果
      const timeTop = setInterval(() => {
        document.body.scrollTop = document.documentElement.scrollTop = top -= 50;
        if (top <= 0) {
          clearInterval(timeTop);
        }
      }, 10);
    },


  }
}
</script>

<style scoped>
.gotop {
  text-align: center;
  position: fixed;
  right: 50px;
  bottom: 30px;
  cursor: pointer;
  padding: 10px;
  border-radius: 50%;
  background: white;
  color: #000000;
  z-index: 100;
}
ul{
  list-style: none;
}
.tem_49_23_c{
  position: fixed;
  top:60%;
  right: 0;
}
.w-cs-icon{
  display: block;
  position: relative;
  z-index: 100;
  width: 40px;
  height: 40px;
  padding: 5px;
  background-color: rgba(86, 171, 226,1);
  background-image: none;
  background-repeat: repeat;
  background-position: 0 0;
  border: solid 1px #fff;
  border-bottom: none;
  text-align: center;
  color: rgba(255,255,255,1);
  text-decoration: none;
}
 .w-cs-menu {
   display: none;
  margin: 0;
  position: absolute;
  top: 15px;
  right: 61px;
  padding: 10px 0;
  background-color: rgba(122, 189, 232,1);
  background-repeat: repeat;
  background-position: 0 0;
  border: solid 1px #fff;
  border-radius: 0px;
  list-style: none;
  white-space: nowrap;
  z-index: 1;
   color: #fff;
   text-align: center;
   height: 160px;
}
 .w-cs-list:hover .w-cs-menu{
   display: block;
   left: -160px !important;
   position: absolute;
 }
.w-cs-menu:hover{
  display: block;
}
.qq{
  display: block;
  text-decoration: none;
  margin-top: 20px;
  color: #fff;
  font-size: 16px;
}
</style>